module.exports = __webpack_public_path__ + "static/media/testimonial_preview.feb3833c.png";